import { SessionExpired as SharedSessionExpired } from "@amzn/it-shop-shared-components";
import { getString } from "@/common/uistringlabels/ui-string-utils";
import { Paths } from "@/common/paths/paths";
import { IT_SHOP_URL } from "@/config";
import React from "react";

const SessionExpired: React.FC = () => (
  <SharedSessionExpired
    strings={{
      title: getString("sessionExpired.title"),
      description: getString("sessionExpired.description"),
      tryAgainButton: getString("sessionExpired.tryAgainButton"),
      returnHomeButton: getString("sessionExpired.returnHomeButton"),
    }}
    onTryAgain={(returnTo) => {
      window.location.assign(returnTo || Paths.search.url);
    }}
    onReturnHome={() => {
      window.location.assign(IT_SHOP_URL);
    }}
  />
);

export default SessionExpired;
